module.exports = __webpack_public_path__ + "img/mob1.2d4b9040.png";